import * as R from 'ramda';

import { QR_CODE_DEFAULT_SETTINGS } from '../../screens/ScreenJourneys/ViewEditor/EditorTabs/ViewEditorTab/JourneyCreativesQrCodeCustomizationForm/QrCodeDefaultSettings';
import { FlipperService } from '../../../start/support/flipper/FlipperService';
import { CUSTOM_QR_JOURNEYS } from '../../../../../shared/constants/flipperFlags';
import { getCleanRuleObject } from '../../screens/ScreenJourneys/utils/RuleUtils';

import type { Rule, View, ViewData } from '../../types/journeyTypes';

export class JourneyReducerService {
  public static getDefaultViewData(): ViewData {
    return {
      tags: [],
    };
  }

  public static getCleanViewObject(): View {
    return {
      title: 'New View',
      template: '',
      type: 'BANNER',
      archived: false,
      data: this.getDefaultViewData(),
      app_id: '',
      id: '',
    };
  }

  public static addQrCodeSettingsToView(view) {
    if (view?.data) {
      if (typeof view?.data === 'string') {
        const parsedViewData = JSON.parse(view?.data);
        if (!parsedViewData?.qrCodeSettings) {
          const viewData = { ...parsedViewData, qrCodeSettings: QR_CODE_DEFAULT_SETTINGS };
          view.data = JSON.stringify(viewData);
        }
      } else {
        if (!view?.data?.qrCodeSettings) {
          view.data.qrCodeSettings = QR_CODE_DEFAULT_SETTINGS;
        }
      }
    }
    return view;
  }

  public static parseStringViewDataToObject(view) {
    if (view) {
      const viewObject = view;
      if (view?.data) {
        if (typeof view?.data === 'string') {
          viewObject.data = JSON.parse(view?.data);
        }
      } else {
        viewObject.data = this.getDefaultViewData();
      }
      return viewObject;
    }
  }

  public static findViewById(views, id) {
    let localView;
    if (!id || !views?.length) {
      localView = this.getCleanViewObject();
    } else {
      localView = R.find((view) => view.id === id, views);
      localView = this.parseStringViewDataToObject(localView);
      if (FlipperService.getInstance().isActive(CUSTOM_QR_JOURNEYS)) {
        localView = this.addQrCodeSettingsToView(localView);
        if (localView) {
          localView.prevQrCodeSettings = localView?.data?.qrCodeSettings;
        }
      }
    }
    return localView;
  }

  public static addOriginalTitleToRule(rule: Rule) {
    return { ...rule, originalTitle: rule.title };
  }

  public static findScratchpadOrRuleById(state, rule_id) {
    let rule;
    if (rule_id === 'new') {
      rule = state.scratchpad_rule || getCleanRuleObject();
    } else if (!rule_id) {
      rule = getCleanRuleObject();
    } else if (state.scratchpad_rule && state.scratchpad_rule.id === rule_id) {
      rule = state.scratchpad_rule;
    } else {
      if (!state.rules) {
        rule = getCleanRuleObject();
      } else {
        rule = state.dictionaryRules.get(rule_id);
      }
    }

    if (!rule) {
      rule = getCleanRuleObject();
      rule.id = rule_id;
    }

    return rule;
  }

  public static mapArrToDictionary = (arr, propertyId = 'id') => {
    return new Map(arr.map((obj) => [obj[propertyId], obj]));
  };

  public static mapDictionaryToArray = (dictionary) => {
    return Array.from(dictionary.values());
  };
}
